(function () {

  if (window.__ORDER_SOURCE_ENGINE_V8__) return;
  window.__ORDER_SOURCE_ENGINE_V8__ = true;

  const STORAGE_KEY = "ORDER_SOURCE_LAST_V8";
  const COOKIE_KEY  = "order_source_checkout";
  const MAX_SYNC_ATTEMPTS = 5;
  const SYNC_INTERVAL = 800;

  let syncAttempts = 0;
  let synced = false;
  let inFlight = false;

  /* ======================================================
     DETECT ORDER SOURCE (Improved)
  ====================================================== */
  function detectOrderSource() {
    try {
      const ua = navigator.userAgent || "";
      const vendor = navigator.vendor || "";
      const platform = navigator.platform || "";

      if (!ua) return "Unknown";

      //  Detect your app first
      if (ua.includes("BabyHumodApp_iOS")) return "App Order (iOS)";
      if (ua.includes("BabyHumodApp_Android")) return "App Order (Android)";

      const isAndroid = /Android/i.test(ua);
      const isIOS = /iPhone|iPad|iPod/i.test(ua);

      const deviceOS =
        isAndroid ? "Android" :
        isIOS ? "iOS" :
        /Win/i.test(platform) ? "Windows" :
        /Mac/i.test(platform) ? "MacOS" :
        /Linux/i.test(platform) ? "Linux" :
        "Unknown OS";

      const isInApp = /FBAN|FBAV|Instagram|Snapchat|WhatsApp|TikTok|Twitter|Line/i.test(ua);

      let browser = "Unknown";
      if (/SamsungBrowser/i.test(ua)) browser = "Samsung Internet";
      else if (/Edg/i.test(ua)) browser = "Edge";
      else if (/OPR|Opera/i.test(ua)) browser = "Opera";
      else if (/Firefox/i.test(ua)) browser = "Firefox";
      else if (/Chrome/i.test(ua)) browser = "Chrome";
      else if (/Safari/i.test(ua)) browser = "Safari";

      if (isInApp) return "In-App Browser Order";

      return "Website Order (" + deviceOS + " - " + browser + ")";
    } catch {
      return "Unknown";
    }
  }

  /* ======================================================
     COOKIE
  ====================================================== */
  function setCookie(name, value, seconds) {
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      "; path=/; max-age=" + seconds + "; SameSite=Lax";
  }

  function getCookie(name) {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith(name + "="))
      ?.split("=")[1];
  }

  /* ======================================================
     SOURCE STORAGE
  ====================================================== */
  function getSourceSafe() {
    let source =
      localStorage.getItem(STORAGE_KEY) ||
      decodeURIComponent(getCookie(COOKIE_KEY) || "") ||
      detectOrderSource();

    localStorage.setItem(STORAGE_KEY, source);
    setCookie(COOKIE_KEY, source, 86400);

    return source;
  }

  /* ======================================================
     SYNC CART (Optimized)
  ====================================================== */
  function syncCart() {
    if (synced || inFlight || syncAttempts >= MAX_SYNC_ATTEMPTS) return;

    inFlight = true;
    syncAttempts++;

    const source = getSourceSafe();

    fetch("/cart.js")
      .then(r => r.json())
      .then(cart => {
        if (cart?.attributes?.["Order Source"] === source) {
          synced = true;
          return;
        }
        // an empty cart is not tagged: writing to it would create a cart for every visitor (abandoned-cart noise);
        // the add-to-cart hook below and the checkout beacon tag it as soon as it matters
        if (!cart || !cart.item_count) return;

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({
            attributes: { "Order Source": source }
          })
        }).then(r => { if (r.ok) synced = true; });
      })
      .catch(() => {})
      .finally(() => { inFlight = false; });
  }

  // after anything is added to the cart (theme form, quick add, the assistant) the cart exists → tag it
  const rawFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = rawFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url) && !(init && init.body && String(init.body).includes("Order Source"))) {
      p.then(r => { if (r.ok && !synced) { syncAttempts = 0; setTimeout(syncCart, 300); } }).catch(() => {});
    }
    return p;
  };

  /* ======================================================
     EXPRESS CHECKOUT SAFE SAVE
  ====================================================== */
  function forceSaveBeforeCheckout() {
    if (synced) return; // already saved by syncCart
    try {
      const source = getSourceSafe();
      navigator.sendBeacon("/cart/update.js", new Blob([JSON.stringify({ attributes: { "Order Source": source } })], { type: "application/json" }));
    } catch {}
  }

  /* ======================================================
     BOOT
  ====================================================== */
  function boot() {
    getSourceSafe();
    syncCart();
    setTimeout(syncCart, SYNC_INTERVAL);
  }

  document.addEventListener("DOMContentLoaded", boot);

  /* ======================================================
     EXPRESS CHECKOUT GUARD
  ====================================================== */
  ["pointerdown","touchstart","mousedown"].forEach(evt => {
    document.addEventListener(evt, forceSaveBeforeCheckout, {
      capture: true,
      passive: true
    });
  });

})();
